// extracted by mini-css-extract-plugin
export default {"base":"DialogConfirmationModVersionRemove_base__3ywHR","content":"DialogConfirmationModVersionRemove_content__uzrMe","button":"DialogConfirmationModVersionRemove_button__x4b-b"};